import React from 'react';
import { connect } from 'react-redux';

import PreSection from './PreSection';
import PassengersAttachments from './PassengersAttachments';
import AirRefundAttachments from './AirRefundAttachments';
import CourtAttachments from './CourtAttachments';
import Section from './Section';
import Summary from './Summary';

const FNRouter = ({
  options,
  fullOptionsData,
  onSelectChange,
  onMultiSelectChange,
  onDateChange,
  claimId,
  sectionsData,
  onTemplateInputChange,
  stages,
  currentStage,
  currentSection,
  navButtonsProps,
  fullPaxFieldsData,
  selectedPassengers,
  taskType,
  documentType,
  taskValues,
  setTaskValues
}) => {
  const currentStageIndex = stages.findIndex(stage => stage === currentStage);
  const renderStage = () => {
    if (currentStageIndex === 0)
      return PreSection({
        options,
        fullOptionsData,
        onSelectChange,
        onMultiSelectChange,
        onDateChange,
        ...navButtonsProps
      });
    if (currentStageIndex === 1)
      return PassengersAttachments({
        navButtonsProps,
        claimId,
        selectedPassengers,
        taskValues,
        setTaskValues,
        taskType
      });
    if (currentStage === 'airRefund attachments')
      return AirRefundAttachments({
        navButtonsProps,
        claimId,
        selectedPassengers,
        taskValues,
        setTaskValues,
        taskType
      });
    if (currentStage === 'court attachments')
      return CourtAttachments({
        navButtonsProps,
        claimId,
        selectedPassengers,
        taskValues,
        setTaskValues,
        taskType
      });

    if (currentStageIndex >= 2 && currentStageIndex < stages.length - 1)
      return (
        <Section
          navButtonsProps={navButtonsProps}
          currentStage={currentStage}
          sectionsData={sectionsData}
          fullPaxFieldsData={fullPaxFieldsData}
          sectionFields={
            sectionsData &&
            sectionsData[currentStage][currentSection].sectionFields
          }
          template={
            sectionsData && sectionsData[currentStage][currentSection].template
          }
          onTemplateInputChange={onTemplateInputChange}
          taskType={taskType}
        />
      );
    return (
      <Summary
        navButtonsProps={navButtonsProps}
        claimId={claimId}
        selectedPassengers={selectedPassengers}
        documentType={documentType}
        taskType={taskType}
        setTaskValues={setTaskValues}
      />
    );
  };
  return <div>{renderStage()}</div>;
};

const mapStateToProps = ({ formalNotice, courtApplication }, { taskType }) => {
  const taskName = taskType === 'LFN' ? formalNotice : courtApplication;
  return {
    selectedPassengers:
      taskName && taskName.options && taskName.options.passengerTicketIds
  };
};
export default connect(mapStateToProps)(FNRouter);



// WEBPACK FOOTER //
// ./src/component/TaskCreator/FNRouter.js